import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import { ClienteSituacao } from "core/features/cliente/typings";
import colors from "core/resources/theme/colors";

const SelectableTag = ({
  value,
  tipo,
  text,
  onChange,
  onUnselect,
}: {
  value?: ClienteSituacao | null;
  tipo: ClienteSituacao;
  text: string;
  onChange: (v: ClienteSituacao | null) => void;
  onUnselect: () => any;
}) => (
  <SelectableButton
    selected={value === tipo}
    onClick={() => {
      onChange(tipo);
    }}
    onUnselect={onUnselect}
    rounded="full"
    selectedColor={getColor(tipo)}
    fontSize="14px"
  >
    {text}
  </SelectableButton>
);

function TableTags({
  value,
  onChange,
}: {
  value?: ClienteSituacao | null;
  onChange: (v?: ClienteSituacao | null) => void;
}) {
  const onUnselect = () => onChange(null);

  return (
    <Flex flex={1} gridGap="12px" flexWrap="wrap">
      <SelectableTag
        tipo={ClienteSituacao.Adimplente}
        text="Adimplente"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={ClienteSituacao.Inadimplente}
        text="Inadimplente"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={ClienteSituacao.Novo}
        text="Novo cliente"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />
    </Flex>
  );
}

export function getColor(tipo: ClienteSituacao) {
  if (tipo === ClienteSituacao.Adimplente) {
    return "#4EC98A";
  }

  if (tipo === ClienteSituacao.Inadimplente) {
    return colors.red;
  }

  if (tipo === ClienteSituacao.Novo) {
    return "#ABACF7";
  }
}

export default TableTags;
